import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';

@Component({
  selector: 'app-exhibition-success',
  templateUrl: './exhibition-success.page.html',
  styleUrls: ['./exhibition-success.page.scss'],
})
export class ExhibitionSuccessPage implements OnInit {

  image = "";

  constructor(
    private remoteConfig: RemoteConfigService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getImage();
  }

  getImage() {
    this.remoteConfig.getImages().subscribe(res => {
      this.image = res;
    });
  }

  new(){
    this.router.navigate(['app/exhibitions/form']);
  }

  cancel(){
    this.router.navigate(['app/exhibitions']);
  }

}
